/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    ApiResultOfListOfJsonApiLogInfo,
    ApiResultOfListOfJsonApiLogInfoFromJSON,
    ApiResultOfListOfJsonApiLogInfoToJSON,
} from '../models';

export interface GetApiLogListUsingGETRequest {
    eventId?: number;
    apiType?: GetApiLogListUsingGETApiTypeEnum;
    apiResult?: GetApiLogListUsingGETApiResultEnum;
    search?: string;
    orderCol?: string;
    orderDir?: string;
    start?: number;
    rows?: number;
}

/**
 * 
 */
export class ApiLogControllerApi extends runtime.BaseAPI {

    /**
     * getApiLogList
     */
    async getApiLogListUsingGETRaw(requestParameters: GetApiLogListUsingGETRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<ApiResultOfListOfJsonApiLogInfo>> {
        const queryParameters: any = {};

        if (requestParameters.eventId !== undefined) {
            queryParameters['eventId'] = requestParameters.eventId;
        }

        if (requestParameters.apiType !== undefined) {
            queryParameters['apiType'] = requestParameters.apiType;
        }

        if (requestParameters.apiResult !== undefined) {
            queryParameters['apiResult'] = requestParameters.apiResult;
        }

        if (requestParameters.search !== undefined) {
            queryParameters['search'] = requestParameters.search;
        }

        if (requestParameters.orderCol !== undefined) {
            queryParameters['orderCol'] = requestParameters.orderCol;
        }

        if (requestParameters.orderDir !== undefined) {
            queryParameters['orderDir'] = requestParameters.orderDir;
        }

        if (requestParameters.start !== undefined) {
            queryParameters['start'] = requestParameters.start;
        }

        if (requestParameters.rows !== undefined) {
            queryParameters['rows'] = requestParameters.rows;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/rest-service/api-log/list`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApiResultOfListOfJsonApiLogInfoFromJSON(jsonValue));
    }

    /**
     * getApiLogList
     */
    async getApiLogListUsingGET(requestParameters: GetApiLogListUsingGETRequest = {}, initOverrides?: RequestInit): Promise<ApiResultOfListOfJsonApiLogInfo> {
        const response = await this.getApiLogListUsingGETRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
    * @export
    * @enum {string}
    */
export enum GetApiLogListUsingGETApiTypeEnum {
    Check = 'check',
    Vip = 'vip',
    Catering = 'catering',
    Ammo = 'ammo'
}
/**
    * @export
    * @enum {string}
    */
export enum GetApiLogListUsingGETApiResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}
